export const headerStyleProps = {
    backgroundColor: 'brandBlue',
    display: 'flex',
    flexDirection: 'column',
    padding: '5%',
    alignItems: {base: 'cetner', desktop: 'left'},
    paddingY: {mobileXL: '1rem', base: '.5rem'},
    paddingX: {
        desktop: '7rem',
        tablet: '5.5rem',
        mobileXL: '4.25rem',
        base: '0.75rem',
    },
    minHeight: {
        base: '13rem',
        mobileXL: '18rem',
        desktop: '20rem',
    },
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'accent',
    textAlign: {base: 'center', desktop: 'left'},
};

export const headerTitleStyleProps = {
    color: 'white',
    fontSize: {
        desktop: '2rem',
        tablet: '2rem',
        mobileXL: '1.5rem',
        base: '1rem',
    },
    fontWeight: 'semibold',
};

export const headerTextStyleProps = {
    color: 'white',
    fontSize: {desktop: '1.2rem', mobileXL: '1.25rem', base: '.75rem'},
    fontWeight: 'semibold',
};

export const widgetHeaderLogoStyleProps = {
    fill: 'white',
    width: '4rem',
    height: '5rem',
    marginRight: '1rem',
};
